module.exports = __webpack_public_path__ + "img/BP.ffd16aa9.svg";